<template>
  <div class="css-jl1qws new-order-dialog d-dialog" @click.stop="closeAll" :class="{'is-create': isCreate}">
    <input type="file" style="display: none" id="file" @click.stop="0" @change="fileChange()" ref="file">
    <div class="sc-bdVaJa keQvRI"></div>
    <div class="switch">
      <slide-x-left-transition>
        <div v-show="page.hasPrev">
          <img src="../assets/imgs/right.png" class="left cp" @click="orderChange(-1)">
          <div class="switch-page switch-page-left">{{ page.index }}/{{ page.total }}</div>
        </div>
      </slide-x-left-transition>
      <slide-x-left-transition>
        <div v-show="page.hasNext">
          <img src="../assets/imgs/right.png" class="right cp" @click="orderChange(1)">
          <div class="switch-page switch-page-right">{{ page.index + 2 }}/{{ page.total }}</div>
        </div>
      </slide-x-left-transition>
    </div>
    <slide-x-left-transition>
      <div class="css-wgk558" v-show="isShowThis">
        <div class="css-7bwbxg">
          <div class="d-content" v-loading="loading.order || loading.orderUpdate">
            <header class="c">
              <a href="javascript:void(0);" class="c a-btn" title="复制订单" @click.stop="copyOrder">
                <i class="el-icon-document-copy" style="font-size: 22px; padding: 4px 6px;"></i>
              </a>
              <a href="javascript:void(0);" class="c a-btn" title="删除订单" @click.stop="deleteOrder">
                <img src="../assets/imgs/delete.svg" width="24" height="24">
              </a>
              <a href="javascript:void(0);" class="c a-btn" title="关闭" @click.stop="closeDialog">
                <img src="../assets/imgs/fail1.svg" width="24" height="24">
              </a>
            </header>
            <div class="main main-body">
              <div>
                <div class="l">
                  <!--标题-->
                  <div class="v-title">
                    <h1 v-show="!isEditing('todayIndex')" @click.stop="titleEdit()" class="h title-today-index" :class="{'unactive': !order.todayIndex, 'err': isErr('todayIndex')}">
                    </h1>
                    <h1 v-show="!isEditing('title')" @click.stop="titleEdit()" class="h title-h1" :class="{'unactive required': !order.title, 'err': isErr('title')}">
                      {{ order.title || '填写订单概述' }}
                    </h1>
                    <input @click.stop=";" @keydown.enter="submitEdit('title')" id="title" v-show="isEditing('title')" class="title-edit" placeholder="请填写客户名"
                           v-bind:style="{ height: title.height + 'px'}" v-model="order.title" ref="title">
                    <slide-x-left-transition>
                      <div class="a-b" v-show="isEditing('title')">
                        <a href="javascript:void(0);" class="b-f">
                          <img src="../assets/imgs/ok.svg" v-show="!isSaving('title')" @click.stop="submitEdit('title')">
                          <img src="../assets/imgs/loading1.svg" v-show="isSaving('title')">
                        </a>
                        <a href="javascript:void(0);" @click.stop="cancelEdit('title')" class="b-f"><img src="../assets/imgs/close.svg"></a>
                      </div>
                    </slide-x-left-transition>
                  </div>
                  <!--订单内容-->
                  <div>
                    <h6>订单内容</h6>
                    <div class="v-leixing" @click.stop=";">
                      <el-checkbox @change="submitEdit" v-model="order.isPay">已付款</el-checkbox>
                      <el-checkbox @change="submitEdit" v-model="order.isDeliver">已发货</el-checkbox>
                      <el-checkbox @change="submitEdit" v-model="order.isOutbound">外发</el-checkbox>
                    </div>
                    <div class="v-leixing order-item" v-show="false">
                      <el-radio v-model="order.imgLeixing" label="0">0剪板</el-radio>
                      <el-radio v-model="order.imgLeixing" label="1">1折弯</el-radio>
                      <el-radio v-model="order.imgLeixing" label="2">2激光</el-radio>
                      <el-radio v-model="order.imgLeixing" label="3">3数控</el-radio>
                      <el-radio v-model="order.imgLeixing" label="4">4焊接</el-radio>
                      <el-radio v-model="order.imgLeixing" label="5">5采购</el-radio>
                      <input placeholder="规格">
                    </div>
                    <el-divider></el-divider>
                    <div class="price h" @click.stop="editMoney()">
                      <span v-show="!isEditing('money')">{{ (order.money || order.money == '0' ? order.money : '请输入订单金额...')| toFixed2 }}</span>
                      <form v-show="isEditing('money')" autocomplete="off">
                        <input @click.stop=";" type="number" @keydown.enter="submitEdit()" v-model="order.money" autocomplete="off" id="money" placeholder="输入订单金额" ref="money">
                      </form>
                    </div>
                  </div>
                  <!--订单图片-->
                  <div>
                    <h6>订单图片</h6>
                    <div class="d d-f f-w-w">
                      <div class="o-w-a pics-box">
                        <div v-for="(pic, i) in order.pics" :key="i" @mouseover="setShowPics(i)" @mouseleave="show.pics[i] = false" class="file-item">
                          <div class="pics-box-btns">
                            <slide-x-left-transition>
                              <div class="left-right left cp" v-show="show.pics[i] && i !== 0" @click.stop="movePics(i, -1)">
                                <img src="../assets/imgs/hand-left.svg" class="img-left">
                                左移
                              </div>
                            </slide-x-left-transition>
                            <slide-x-left-transition>
                              <div class="left-right right cp" v-show="show.pics[i] && i !== order.pics.length - 1" @click.stop="movePics(i, 1)">
                                <img src="../assets/imgs/hand-left.svg" class="img-right">
                                右移
                              </div>
                            </slide-x-left-transition>
                            <slide-x-left-transition>
                              <div class="left-right delete cp" v-show="show.pics[i]" @click.stop="deletePic(i)">
                                <img src="../assets/imgs/delete.svg" class="img-right">
                                删除
                              </div>
                            </slide-x-left-transition>
                          </div>
                          <!-- 展示图不要加 crossorigin：OSS 不回 Vary: Origin，若同一 URL 先被
                               no-cors 加载过（查看器/别的列表页），这里的 cors 请求会命中无 ACAO 的
                               缓存条目而报 CORS 错。需要 cors 的地方一律 fetch(..., cache:'no-store')。 -->
                          <img :src="pic | handleUploadFile" @click.stop="viewPics(i, pic)" class="cp pic">
                          <p class="file-name" v-if="!isImage(pic)">
                            {{ pic | handleFileName }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <a class="a-btn" style="text-decoration: underline;" href="javascript:void 0;" @click.stop="$refs.file.click()">点击上传 (或快捷键Ctrl+V上传)</a>
                  </div>
                  <!--备注-->
                  <div>
                    <h6>备注</h6>
                    <div class="d h" v-show="!isEditing('orderDesc')" :class="{err: isErr('orderDesc')}">
                      <div @click.stop="openEditor('#ms-edit', 'orderDesc', $event)" v-if="order.orderDesc" v-html="order.orderDesc" class="html-content w-e-text"></div>
                      <div @click.stop="openEditor('#ms-edit', 'orderDesc', $event)" class="v-a" v-if="!order.orderDesc && !isEditing('orderDesc')">填写订单备注信息...</div>
                    </div>
                    <slide-x-left-transition>
                      <div class="v-edit" v-show="isEditing('orderDesc')" @click.stop=";">
                        <div id="ms-edit"></div>
                        <div class="d-f ms-save-btns">
                          <button class="aui-button primary " @click.stop="submitEditor()">
                            <p v-if="!isSaving('orderDesc')">保存</p>
                            <img v-else="" src="../assets/imgs/loading1.svg" width="28" height="20">
                          </button>
                          <button class="aui-button none" @click.stop="cancelEditor()">取消</button>
                        </div>
                      </div>
                    </slide-x-left-transition>
                  </div>
                </div>
                <div class="r">
                  <div class="d" v-if="order.doneTime">
                    <div class="o-w-a" :title="order.doneTime">完成于：{{ friendlyDate(order.doneTime) }}</div>
                  </div>
                  <!--接单人-->
                  <div>
                    <h6 class="required">接单</h6>
                    <span class="el-dropdown-link user cp" @click="handleClickSpanUser('selectorCreateUser')" v-show="!show.selectorCreateUser" :class="{'err': isErr('createUserId')}">
                        <User :user="order.createUser"></User>
                      </span>
                    <form autocomplete="off" v-show="show.selectorCreateUser">
                      <el-select v-model="order.createUserId"
                                 ref="selectorCreateUser"
                                 filterable
                                 reserve-keyword
                                 default-first-option
                                 remote
                                 @change="setSpanUser(order.createUserId,'createUser','selectorCreateUser')"
                                 :remote-method="loadUser"
                                 :loading="loading.userCreate"
                                 placeholder="请选择">
                        <el-option
                            v-for="item in userList.order"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            class="user">
                          <user :user="item"></user>
                        </el-option>
                      </el-select>
                    </form>
                  </div>
                  <!--客户-->
                  <div>
                    <h6 class="required">客户</h6>
                    <span class="el-dropdown-link user cp" @click.stop="handleClickSpanUser('selectorCustomerUser')" v-show="!show.selectorCustomerUser" :class="{'err': isErr('customerUserId')}">
                        <User :user="order.customerUser"></User>
                      </span>
                    <div style="color: #ccc">
                      累计订单: {{ userPic.customer.total }} 金额: {{ userPic.customer.money |toFixed2 }}
                    </div>
                    <slide-x-left-transition>
                      <form autocomplete="off" v-show="show.selectorCustomerUser">
                        <el-select v-model="order.customerUserId"
                                   @click.stop=""
                                   ref="selectorCustomerUser"
                                   filterable
                                   reserve-keyword
                                   default-first-option
                                   remote
                                   @change="setSpanUser(order.customerUserId,'customerUser','selectorCustomerUser')"
                                   :remote-method="loadUser"
                                   :loading="loading.userList"
                                   placeholder="请选择">
                          <el-option
                              @click.stop=";"
                              v-for="item in userList.customer"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                              class="user">
                            <user :user="item"></user>
                          </el-option>
                        </el-select>
                      </form>
                    </slide-x-left-transition>
                  </div>
                  <!--外发-->
                  <slide-x-left-transition>
                    <div v-show="order.isOutbound">
                      <h6 class="required">外发给</h6>
                      <span class="el-dropdown-link user cp" @click="handleClickSpanUser('selectorOutboundUser')" v-show="!show.selectorOutboundUser" :class="{'err': isErr('outboundUserId')}">
                        <User :user="order.outboundUser"></User>
                      </span>
                      <form autocomplete="off" v-show="show.selectorOutboundUser">
                        <el-select v-model="order.outboundUserId"
                                   ref="selectorOutboundUser"
                                   filterable
                                   reserve-keyword
                                   default-first-option
                                   remote
                                   @change="setSpanUser(order.outboundUserId,'outboundUser','selectorOutboundUser')"
                                   :remote-method="loadUser"
                                   :loading="loading.userList"
                                   placeholder="请选择">
                          <el-option
                              @click.stop=";"
                              v-for="item in userList.outbound"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                              class="user">
                            <user :user="item"></user>
                          </el-option>
                        </el-select>
                      </form>
                    </div>
                  </slide-x-left-transition>
                  <!--下单日期-->
                  <div>
                    <h6 class="required">下单日期</h6>
                    <div class="create-time h" @click.stop="editCreateTime()">
                      <span v-show="!isEditing('createTime')">{{ order.createTime }}</span>
                      <form v-show="isEditing('createTime')" autocomplete="off">
                        <input @click.stop=";" @keydown.enter="submitEdit()" v-model="order.createTime" autocomplete="off" id="createTime" placeholder="输入下单日期" ref="createTime">
                      </form>
                    </div>
                  </div>
                  <!--微信聊天-->
                  <slide-x-left-transition>
                    <div v-show="order.customerUser && order.customerUser.wechatId && false">
                      <h6>微信聊天</h6>
                      <wechat style="max-height: 350px;" :wechat-id="order.customerUser && order.customerUser.wechatId"></wechat>
                    </div>
                  </slide-x-left-transition>
                  <!--更新记录-->
                  <slide-x-left-transition>
                    <div v-show="recordList && recordList.length">
                      <h6>更新记录</h6>
                      <el-timeline :reverse="false">
                        <el-timeline-item
                            v-for="(record, index) in recordList"
                            :key="index"
                            :timestamp="record.updateTime">
                          <span class="user">
                            <User :user="record.updateUser" :show-user-name="false"></User>
                          </span>
                          <div class="record-content">
                            {{ record.updateContent }}
                          </div>
                        </el-timeline-item>
                      </el-timeline>
                    </div>
                  </slide-x-left-transition>
                </div>
              </div>
              <div class="main v-fabu-btn" v-if="!order.id">
                <div class="sx">
                  <button class="btn new-t-btn c" @click="orderCreate"><img src="../assets/imgs/push1.svg" width="16" height="16">下单</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </slide-x-left-transition>
    <ImgViewer ref="imgViewer"></ImgViewer>
  </div>
</template>

<script>
import E from 'wangeditor'
import '../components/wangeditor.css'

import util, {isImage} from "@/util";
import orderModel from "@/assets/models/order";

import ImgViewer from "@/components/ImgViewer";
import moment from 'moment'
import User from "@/components/User";
import Wechat from "@/components/Wechat";

window.moment = moment;

function validFormTmp () {
  this.validForm()
}

function _loadUserPic (id) {
  this.loadUserPic(id)
}

const handlePaste = e => {
  if (!e.clipboardData || !e.clipboardData.items || !window.$xuqiuDialogTask.isShowThis) {
    return;
  }
  let file = false;
  for (let i = 0, len = e.clipboardData.items.length; i < len; i++) {
    let item = e.clipboardData.items[i];
    console.log('paste:', item)
    // if (/image/.test(item.type)) {
    if (item.kind === 'file') {
      file = item.getAsFile();
    }
  }
  console.log('pre upload file: ', file);
  if (file)
    window.$xuqiuDialogTask.uploadImg.call(this, file)
}
const handleKeyDown = e => {
  if (window.$xuqiuDialogTask.show.imgView)
    return
  if (e.key === 'ArrowRight') window.$xuqiuDialogTask.orderChange(1)
  if (e.key === 'ArrowLeft') window.$xuqiuDialogTask.orderChange(-1)
}

export default {
  components: {ImgViewer, User, Wechat},
  data () {
    return {
      order: {},
      isShowThis: false,
      isUserLoading: false,
      userListCurrentType: '',
      userList: {
        order: [],
        outbound: [],
        customer: []
      },
      apiFilter: {
        name: ''
      },
      loading: {
        userList: false,
        order: false,
        orderUpdate: false,
        orderUpdateRecord: false
      },
      show: {
        selectorCustomerUser: false,
        selectorCreateUser: false,
        selectorOutboundUser: false,
        pics: {},
        imgView: false
      },
      title: {width: 200, height: 40},
      pickdateField: '',
      curEditor: null,
      curEditField: null,
      curSavingField: null,
      tmpValue: '',
      isOpenDatePickr: false,
      err: {},
      errMsg: {},
      isFormValid: false,
      isShowStatus: false,
      queueRemaining: 0,
      userPic: {
        customer: {
          money: 0,
          total: 0
        }
      },
      recordList: null,
      page: {
        index: undefined,
        total: 0,
        hasNext: false,
        hasPrev: false,
      },
    }
  },
  inject: ['componentXuqiu'],
  computed: {
    user () {
      return this.$store.state.user;
    },
    isCreate () {
      return !this.order.id;
    },
    // showPrev () {
    //   if (!window.$xuQiu || !window.$xuQiu.realList) return false
    //   let index = window.$xuQiu.realList.findIndex(item => item.id === this.order.id)
    //   return index !== -1 && index !== 0
    // },
    // showNext () {
    //   if (!window.$xuQiu || !window.$xuQiu.realList) return false
    //   let index = window.$xuQiu.realList.findIndex(item => item.id === this.order.id)
    //   return index !== -1 && index !== window.$xuQiu.realList.length - 1
    // }
  },
  methods: {
    orderChange (changeIndex) {
      if (this.loading.order || ['title', 'createTime'].includes(this.curEditField)) return
      console.log('taskNext', changeIndex)
      // let index = window.$xuQiu.realList.findIndex(item => item.id === this.order.id)
      // if (index !== -1) {
      //   // 当最后一个订单不能再切换到下一个订单
      //   if (changeIndex === 1 && index !== window.$xuQiu.realList.length - 1) {
      //     this.loadOrder(window.$xuQiu.realList[index + 1].id)
      //   }
      //   // 当第一个订单不能再切换到上一个订单
      //   if (changeIndex === -1 && index !== 0) {
      //     this.loadOrder(window.$xuQiu.realList[index - 1].id)
      //   }
      // }
      if (changeIndex === 1 && this.page.hasNext || changeIndex === -1 && this.page.hasPrev) {
        this.page.index += changeIndex
        this.$router.replace({
          name: '需求清单-任务',
          params: {
            id: this.order.id + '.' + parseInt(Math.random() * 10),
            rowIndex: this.page.index,
            filter: this.$route.params.filter
          }
        })
      }
    },
    setShowPics (i) {
      let temp = {};
      temp[i] = true;
      this.show.pics = Object.assign({}, this.show.pics, temp)
    },
    orderCreate () {
      this.isFormValid = true
      if (!this.validForm()) return
      let postData = util.clone(this.order)
      postData.pics = JSON.stringify(postData.pics)
      let t = new Date(postData.createTime).getTime()// + 8 * 60 * 60 * 1000
      t = new Date(t)
      postData.createTime = t.Format() + 'T' + t.Format('HH:mm:ss')
      postData.orderLoginUserId = this.user.id
      this.$post('/order/create', postData, () => {
        this.closeDialog()
        window.$xuQiu.reloadData()
      })
    },
    isImage (pic) {
      return isImage(pic)
    },
    viewPics (i, url) {
      if (isImage(url)) {
        this.$refs.imgViewer.init(this.order.pics, i)
        this.show.imgView = true
      } else
        window.open(url)
    },
    openEditor (selector, field, event) {
      // 如果点击的是描述中的图片，那么只预览图片就好
      if (event.target.tagName === 'IMG') {
        let imgs = [];
        this.$('.html-content.w-e-text').find('img').each((i, img) => {
          imgs.push(this.$(img).attr('src'))
        })
        let curSrc = this.$(event.target).attr('src');
        console.log('open viewer:', imgs)
        let self = this;
        imgs = Array.from(imgs, item => self.img(item));
        this.$refs.imgViewer.init(imgs, imgs.indexOf(curSrc))
        return
      }
      if (field === 'orderDesc') {
        let menus = [
          'bold',  // 粗体
          'fontSize',  // 字号
          'italic',  // 斜体
          'underline',  // 下划线
          'foreColor',  // 文字颜色
          'link',  // 插入链接
          'list',  // 列表
          'justify',  // 对齐方式
          'image',  // 插入图片
          'video',  // 插入视频
          'undo',  // 撤销
          'redo'  // 重复
        ]
        this.curEditor = new E(selector)
        this.curEditor.config.menus = menus;
        this.curEditor.config.uploadImgMaxLength = 5;
        this.curEditor.config.customUploadImg = (resultFiles, insertImgFn) => {
          resultFiles.forEach(file => {
            const done = (f) => {
              const ext = (f.name && f.name.indexOf('.') >= 0) ? f.name.split('.').pop().toLowerCase() : (f.type ? f.type.split('/').pop() : 'png')
              this.$get('/oss/sign', { ext: ext, dir: 'img' }).then(sign => {
                const fd = new FormData()
                fd.append('key', sign.key)
                fd.append('OSSAccessKeyId', sign.ossAccessKeyId)
                fd.append('policy', sign.policy)
                fd.append('signature', sign.signature)
                fd.append('success_action_status', '200')
                fd.append('file', f)
                this.$axios({ method: 'post', url: sign.host, data: fd, withCredentials: false }).then(() => {
                  insertImgFn(sign.url)
                }).catch(e => { console.error('wangEditor OSS 上传失败', e); this.$msg('图片上传失败', 'error') })
              }).catch(e => { console.error('获取签名失败', e); this.$msg('获取上传签名失败', 'error') })
            }
            // 原图直传 OSS（不压缩，保证质量）
            done(file)
          })
        }
        this.curEditor.create()
        this.curEditor.txt.html(this.order[field])
        this.tmpValue = this.order[field]
        this.curEditField = field
      }
    },
    cancelEditor () {
      this.order[this.curEditField] = this.tmpValue;
      this.curEditor.destroy()
      this.curEditor = null
      this.curEditField = null
    },
    destroyEditor () {
      if (this.curEditor) {
        this.curEditor.destroy()
        this.curEditor = null
        this.curEditField = null
        this.curSavingField = null
        this.tmpValue = ''
      }
    },
    submitEditor () {
      if (!this.curEditor) return
      this.order[this.curEditField] = this.curEditor.txt.html();
      if (!this.isCreate) {
        if (this.curSavingField) return
        this.curSavingField = this.curEditField;
        this.orderUpdate().then(() => {
          this.destroyEditor()
        }).catch(() => {
          this.destroyEditor()
        })
      } else
        this.destroyEditor()
    },
    isEditing (field) {
      return this.curEditField === field;
    },
    isSaving (field) {
      return this.curSavingField === field;
    },
    cancelEdit () {
      this.order[this.curEditField] = this.tmpValue;
      this.curEditField = null;
    },
    openEdit (field) {
      this.tmpValue = this.order[field];
      this.curEditField = field;
    },
    submitEdit () {
      let self = this;

      function endEdit () {
        self.tmpValue = '';
        self.curSavingField = null;
        self.curEditField = null;
      }

      if (self.order.id) {
        if (self.curSavingField) return
        self.curSavingField = self.curEditField;
        self.orderUpdate().then(endEdit).catch(() => {
          self.order[self.curSavingField] = self.tmpValue
          endEdit();
        })
      } else
        endEdit(self)
    },
    movePics (picIndex, move) {
      let temp = this.order.pics[picIndex]
      this.order.pics[picIndex] = this.order.pics[picIndex + move]
      this.order.pics[picIndex + move] = temp
      this.submitEdit()
    },
    deletePic (i) {
      this.order.pics.splice(i, 1)
      this.submitEdit()
    },
    titleEdit () {
      // if (!this.isCreate) return
      // let $h1 = this.$('.l h1').eq(0);
      // this.title.width = $h1.width() - 2;
      // this.title.height = $h1.height() - 2;
      // this.title.width = '100%'
      setTimeout(() => {
        this.$refs.title.focus()
        this.$refs.title.select()
      }, 50)
      this.openEdit('title')
    },
    editMoney () {
      this.openEdit('money')
      setTimeout(() => {
        this.$refs.money.focus()
        this.$refs.money.select()
      }, 50)
    },
    editCreateTime () {
      this.openEdit('createTime')
      setTimeout(() => {
        this.$refs.createTime.focus()
        this.$refs.createTime.select()
      }, 50)
    },
    closeDialog () {
      // this.componentXuqiu.loadData();
      this.$router.push('/')
      // this.$router.back()
    },
    closeAll () {
      console.log('close all')
      if (this.curEditField) {
        this.submitEdit()
      }
      // if (['createUserId', 'status', 'customerUserId'].indexOf(this.curEditField) !== -1)
      //   this.curEditField = null
    },
    loadUser (query) {
      let type = this.userListCurrentType
      this.loading.userList = true
      const roleId = {
        order: 6,
        outbound: 2
      }
      this.$get('/user/list/last-online', {name: query, roleId: roleId[type]}, (res) => {
        this.userList[type] = res;
        this.loading.userList = false
      })
    },
    handleClickSpanUser (key) {
      this.userListCurrentType = {
        'selectorCreateUser': 'order',
        'selectorOutboundUser': 'outbound',
        'selectorCustomerUser': 'customer'
      }[key]
      this.loadUser()
      this.show[key] = true
      setTimeout(() => this.$refs[key].focus(), 50)
    },
    // userId=1 key=createUser selectorKey=selectorCreateUser
    setSpanUser (userId, key, selectorKey) {
      this.order[key] = this.userList[this.userListCurrentType].filter(item => item.id === userId)[0]
      this.order[key + "Id"] = userId
      this.show[selectorKey] = false
      this.submitEdit()
      this.closeAll()
    },
    orderUpdate () {
      return new Promise((resolve, reject) => {
        if (this.loading.orderUpdate)
          reject()
        this.isFormValid = true
        if (!this.validForm()) {
          this.$msg('请填写必填项', 'error')
          reject()
        } else {
          this.loading.orderUpdate = true
          let postData = Object.assign({}, this.order)
          postData.pics = JSON.stringify(postData.pics)
          this.$post('/order/update?userId=' + this.user.id, postData, res => {
            // this.componentXuqiu.loadData();
            res.data.pics = JSON.parse(res.data.pics)
            this.order = res.data
            this.loading.orderUpdate = false
            window.$xuQiu.reloadData()
            this.loadOrderUpdateRecord(this.order.id)
            resolve()
          }, () => {
            this.loading.orderUpdate = false
            reject()
          })
        }
      });
    },
    validForm () {
      let errTmp = {};
      let errMsgTmp = {};
      util.reg.notEmpty(this.order, 'title', errTmp, errMsgTmp)
      util.reg.notEmpty(this.order, 'createUserId', errTmp, errMsgTmp)
      util.reg.notEmpty(this.order, 'customerUserId', errTmp, errMsgTmp)
      this.err = Object.assign(this.err, errTmp)
      this.errMsg = Object.assign(this.errMsg, errMsgTmp)
      this.$forceUpdate()
      return !util.reg.hasError(this.err);
    },
    isErr (field) {
      return this.isFormValid && this.err[field];
    },
    isUrl (url) {
      return util.isUrl(url)
    },
    deleteOrder () {
      var self = this;
      let _layerConfirmId = self.$layer.confirm('删除后不可恢复，确认删除？', () => {
        self.$get('/order/del?userId=' + this.user.id, {id: this.order.id}, () => {
          self.$parent.loadData()
          self.closeDialog();
          self.$layer.close(_layerConfirmId)
        })
      })
    },
    copyOrder () {
      this.order.id = null
      this.$msg('订单复制成功')
      this.recordList = null
    },
    friendlyDate (date) {
      return util.friendlyDate1(date)
    },
    toDate (date) {
      return util.toDate(date)
    },
    fileChange () {
      let file = event.currentTarget.files[0];
      event.currentTarget.value = ''
      this.uploadImg(file)
    },
    async uploadImg (file) {
      if (!file) return
      // 原图直传 OSS（不压缩，保证质量）
      console.log('upload file', file)
      this.$uploadOss('/upload', {file: file, userId: this.user.id}, res => {
        console.log('upload:', res)
        this.order.pics.push(res[0])
        this.submitEdit()
      })
    },
    loadUserPic (id) {
      if (!id) return
      this.$get('/order/user-pic', {id: id}, res => {
        this.userPic.customer.money = res.money
        this.userPic.customer.total = res.total
      })
      validFormTmp.call(this)
    },
    loadOrderUpdateRecord (id) {
      this.loading.orderUpdateRecord = true
      this.$get('/order-update-record/list', {orderId: id}).then(res => {
        this.recordList = res
        this.loading.orderUpdateRecord = false
      })
    },
    loadOrder () {
      this.loading.order = true
      let promise
      console.log(JSON.parse(JSON.stringify(this.page)))
      if (!isNaN(this.page.index) && typeof this.page.index === 'number') {
        let filter = this.$route.params.filter
        filter.rowIndex = this.$route.params.rowIndex
        promise = this.$get('/order/get-by-index', filter)
      } else
        promise = this.$get('/order', {id: parseInt(this.$route.params.id)})

      promise.then(res => {
        if (typeof res.hasPrev !== 'boolean') {
          res = {
            hasNext: false,
            hasPrev: false,
            total: 1,
            order: res
          }
        }
        res.order.pics = JSON.parse(res.order.pics)
        this.page.hasPrev = res.hasPrev
        this.page.hasNext = res.hasNext
        this.page.total = res.total

        this.order = res.order
        this.isShowThis = true
        this.loading.order = false
        this.loadOrderUpdateRecord(this.order.id)

        // 仅仅为了记住地址,不进行页面上的跳转
        this.$router.replace({
          name: '需求清单-任务',
          params: {
            id: this.order.id + '.' + parseInt(Math.random() * 10 + ''),
            rowIndex: this.page.index,
            filter: this.$route.params.filter,
            onlyReplaceUrl: true
          }
        })
      })
    }
  },
  watch: {
    'order.title': validFormTmp,
    'order.orderDesc': validFormTmp,
    'order.createUserId': validFormTmp,
    'order.customerUserId': _loadUserPic,
    user () {
      return this.$store.state.user;
    },
    $route (r) {
      if (r.params.onlyReplaceUrl)
        return
      this.loadOrder()
    }
  },
  mounted () {
    window.$xuqiuDialogTask = this;
    window.$dropdownCreateUser = this.$refs.dropdownCreateUser;
    document.addEventListener('paste', handlePaste)
    document.addEventListener('keydown', handleKeyDown)
    // 锁定 body 滚动，防止详情打开时列表滚动
    document.body.style.overflow = 'hidden'
  },
  created () {
    let self = this;

    function newOrder () {
      self.order = util.clone(orderModel);
      self.order.createTime = new Date().Format('yyyy-MM-dd HH:mm:ss')
      // self.order.createUserId = self.user.id;
      // self.order.createUser = self.user
      self.order.customerUserId = 1
      self.order.customerUser = {
        name: '无名',
        id: 1
      }
    }

    this.page.index = parseInt(this.$route.params.rowIndex)
    let id = parseInt(this.$route.params.id);
    if (id || this.page.index) {
      this.loadOrder()
    } else {
      newOrder()
      this.$nextTick(() => {
        this.isShowThis = true
      })
    }
  },
  beforeDestroy () {
    document.removeEventListener('paste', handlePaste)
    document.removeEventListener('keydown', handleKeyDown)
    this.destroyEditor()
    // 恢复 body 滚动
    document.body.style.overflow = ''
  },
}
</script>

<style scoped>
.record-content {
  max-width: calc(100% - 34px);
  padding: 5px 0 0 5px;
}

#countImg {
  width: auto;
}

.pri .menu {
  width: 100%;
  top: 33px;
}

.fenpei .menu {
  width: 100%;
  max-height: 130px;
  overflow: auto;
  bottom: auto;
  top: 41px;
}

.ms-save-btns button > img {
  width: 28px;
  height: 20px;
}

.ms-save-btns button {
  margin-right: 5px;
}

.mx-datepicker {
  width: 130px;
}

.p0 {
  padding: 0;
}

h6 {
  white-space: nowrap;
}

.b-f {
  background-color: #fff;
}

.main-body > div {
  display: flex;
}

.main-body {
  display: block;
}

.a-btn img {
  padding: 4px 6px;
}

.d-star p {
  margin-right: 5px;
}

.d-star {
  display: flex;
  align-items: center;
}

.d-star:last-child {
  margin-bottom: 10px;
}

#inp-hs {
  width: 90px;
  padding-right: 10px;
}

.v-leixing[disable] label,
div[disable] > div:hover {
  cursor: auto;
  background-color: unset;
}

.el-dropdown {
  width: 100%;
}

.is-create .el-dropdown {
  cursor: pointer;
}

.pics-box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.file-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  max-width: 320px;
  align-self: flex-start;
}

.pics-box-btns {
}

.pics-box > div {
  position: relative;
}

.pics-box .pic {
  max-width: 300px;
  max-height: 400px;
  margin: 0 10px 5px;
  box-shadow: 0 0 4px 1px #ccc;
  border-radius: 2px;
  min-width: 150px;
  object-fit: cover;
}

.file-name {
  margin-bottom: 10px;
}

.pics-box .left-right {
  position: absolute;
  bottom: 17px;
  left: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffffc4;
  padding: 0 5px;
  border-radius: 3px;
  font-size: 10px;
  box-shadow: 0 0 3px 0 #ffffffbd;
  transition: background-color .2s, color .2s;
}

.pics-box .left-right:hover {
  background: #5160796e;
  color: #fff;
  box-shadow: 0 0 3px 0 #5160796e;
}

.pics-box .left-right.right {
  right: 12px;
  left: unset;
  flex-direction: row-reverse;
}

.pics-box .left-right.delete {
  right: 12px;
  left: unset;
  bottom: unset;
  top: 3px;
  flex-direction: row-reverse;
}

.pics-box .left-right.delete .img-right {
  width: 20px;
  padding: 3px 2px;
}

.pics-box .left-right .img-left,
.pics-box .left-right .img-right {
  width: 25px;
}

.pics-box .left-right .img-right {
  transform: rotateY(180deg);
}

.order-item input {
  width: 100px;
}

.price {
  display: flex;
  justify-content: flex-end;
  padding: 5px 15px 5px 0;
}

.create-time {
  padding: 3px 5px;
}

.price span {
  font-size: large;
  font-weight: bold;
}

.el-divider--horizontal {
  margin: 12px 0;
}

.switch {
}

.switch .left,
.switch .right {
  position: absolute;
  z-index: 520;
  width: 50px;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 3px;
  padding: 5px 0;
  transition: background-color .2s;
}

.switch .left:hover,
.switch .right:hover {
  background: #cccccc3b;
}

.switch .left {
  left: 50px;
  transform: translateY(-50%) rotateZ(180deg);
}

.switch .right {
  right: 50px;
}

.switch-page {
  position: absolute;
  z-index: 520;
  top: calc(50% + 30px);
  color: #fff;
  text-align: center;
  width: 55px;
}

.switch-page-left {
  left: 50px;
}

.switch-page-right {
  right: 50px;
}

@media only screen and (max-width: 749px) {
  .d-content header {
    padding: 0;
    height: 66px;
  }

  .main-body > div {
    flex-direction: column;
  }

  .switch .left,
  .switch .right {
    background: #00000063;
  }

  .switch .left {
    left: 0;
  }

  .switch .right {
    right: 0;
  }

  .switch .left:hover,
  .switch .right:hover {
    background: #00000063;
  }
}
</style>
<style>
.el-timeline-item__content {
  display: flex;
  align-items: center;
}
</style>
